export enum SettingsTab {

    Funds = "funds",
    Profile = "profile",
    FinancialSummary = "financialSummary",
    Legal = "legal"
}
